import { render } from "./TabView.vue?vue&type=template&id=9a9cb44e"
import script from "./TabView.vue?vue&type=script&lang=js"
export * from "./TabView.vue?vue&type=script&lang=js"

import "./TabView.vue?vue&type=style&index=0&id=9a9cb44e&lang=css"
script.render = render

export default script